export default "__VITE_ASSET__DnXTCkLw__"